import React from 'react';
import filterIcon from '../../../../assets/image/filter-black-icon.svg';
import Button from '../../../../component/ui/Button';
import FilterRender from './filterRender';
import DatePicker from 'react-datepicker';
// const FILTERS = [
// 	{
// 		type: 'dropdown',
// 		label: 'Date Range',
// 		key: 'date_range',
// 		options: DATE_RANGE,
// 		isCustom: true,
// 	},
// 	{
// 		type: 'checkbox',
// 		label: 'Transactions Type',
// 		key: 'transaction_type',
// 		options: TRANSACTION_TYPE,
// 	},
// ];

export default function ReportSubHeaderComponent({
	getReportList,
	params,
	setParams,
	startDate,
	endDate,
	setCustomDateRange,
	dropdownState,
	setDropdownState,
	filters,
}) {
	return (
		<div className="d-flex gap-3 py-4 px-3 align-items-center">
			<img
				className="cursor-pointer"
				style={{ width: '16px', height: '16px' }}
				src={filterIcon}
				alt="filter-icon"
			/>

			<div
				className="fs-5 fw-semibold"
				style={{ color: '#0F1C35' }}
			>
				Filters:
			</div>

			{filters.map((filter) => (
				<FilterRender
					key={filter.key}
					filter={filter}
					params={params}
					setParams={setParams}
					state={dropdownState}
					setState={setDropdownState}
				/>
			))}

			{dropdownState.isCustomDateOpen && (
				<DatePicker
					selectsRange
					startDate={startDate}
					endDate={endDate}
					onChange={(update) => setCustomDateRange(update)}
					isClearable={true}
					maxDate={new Date()}
				/>
			)}

			<Button
				type="button"
				className="btn-gray mt-0 px-4"
				button="Run Report"
				onClick={() => getReportList()}
			/>
		</div>
	);
}
